import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vk': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M545 117.7c-7.4 34.3-79.3 135.5-79.4 135.6-6.2 10-8.7 15 0 26.2 3.4 4.8 79.1 76.6 90.3 111.5 4.9 16.6-3.6 25-20.4 25h-58.9c-22.4 0-29-17.9-69-57.9-35-33.7-50-38.1-58.7-38.1-18.8 0-15.4 6.3-15.4 73.1 0 14.5-4.6 22.9-42.1 22.9-62.4 0-131-37.9-179.7-107.8-73.1-102.4-93.1-179.9-93.1-195.5 0-8.8 3.4-16.7 20.2-16.7h58.9c15.1 0 20.8 6.6 26.6 22.9 28.8 84 77.4 157.4 97.4 157.4 7.5 0 10.9-3.5 10.9-22.5v-86.8c-2.2-40-23.4-43.3-23.4-57.5 0-6.5 5.6-13.5 15-13.5h92.6c12.4 0 16.6 6.7 16.6 21.7v116.7c0 12.5 5.7 16.9 9.4 16.9 7.5 0 13.8-4.4 27.5-18.1 42.4-47.4 72.4-120.5 72.4-120.5 3.7-8.8 10.6-16.7 25.6-16.7h58.9c17.8 0 21.5 9.2 17.8 21.7z'
      }
    ]
  }
})
